import moment from "moment";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { classNames } from "../../../helpers";
import { DevicePhoneMobileIcon, EnvelopeIcon, PhoneIcon } from "@heroicons/react/20/solid";

/** Icons from the original My Members pages: Heroicons envelope/phone and the WhatsApp logo. */
export { EnvelopeIcon, PhoneIcon };
export function WhatsAppIcon({ className = "size-5" }) {
  return (
    <svg viewBox="0 0 640 640" className={className} fill="currentColor" aria-hidden="true">
      <path fillRule="evenodd" d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0" />
    </svg>
  );
}

/**
 * How the member signs in (users.socialType): normal = mobile number + password, apple, google (facebook is old).
 * Returns null for anything else, so an unknown or missing value shows nothing.
 */
const LOGIN_METHODS = {
  normal: "Mobile",
  apple: "Apple",
  ios: "Apple",
  google: "Google",
  facebook: "Facebook",
};
export const loginMethodOf = (u) => LOGIN_METHODS[String(u?.socialType || "").trim().toLowerCase()] || null;

function LoginMethodIcon({ method, className = "size-4" }) {
  if (method === "Google")
    return (
      <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
        <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
        <path fill="#FF3D00" d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
        <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
        <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
      </svg>
    );
  if (method === "Apple")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
      </svg>
    );
  if (method === "Facebook")
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="12" fill="#1877F2" />
        <text x="12.6" y="18" textAnchor="middle" fontSize="16" fontWeight="700" fontFamily="Arial, sans-serif" fill="#fff">f</text>
      </svg>
    );
  return <DevicePhoneMobileIcon aria-hidden="true" className={className} />;
}

/** "Mobile login" / "Apple login" / "Google login" with its icon, styled like the phone and email next to it. */
export function LoginMethod({ user, className = "" }) {
  const method = loginMethodOf(user);
  if (!method) return null;
  return (
    <span className={classNames("flex items-center gap-1.5 whitespace-nowrap", className)} title={`Signs in with ${method === "Mobile" ? "their mobile number" : method}`}>
      <LoginMethodIcon method={method} className="size-4 shrink-0 text-gray-400" />
      {method} login
    </span>
  );
}

/** Shared helpers for the new My Members pages (list, member page, drawers). */

export const TONES = {
  green: "bg-[#E8F7EE] text-[#1F6B3A]",
  amber: "bg-[#FFF4E5] text-[#7A4A00]",
  gray: "bg-[#F1EEF2] text-[#595159]",
  red: "bg-[#FFE8EB] text-[#B4232F]",
  lilac: "bg-[#F3E9FF] text-[#6A00BA]",
  blue: "bg-[#E7F0FF] text-[#1D4ED8]",
};

export function Badge({ tone = "gray", children, className = "" }) {
  return <span className={classNames("inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-extrabold", TONES[tone] || TONES.gray, className)}>{children}</span>;
}

const AVATAR_BG = ["#F64E60", "#7e00dd", "#481B3A", "#0F8B8D", "#D97706", "#2563EB"];
const hash = (s) => String(s || "").split("").reduce((n, c) => (n * 31 + c.charCodeAt(0)) >>> 0, 7);
export const initialsOf = (name) =>
  String(name || "?")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .filter((c) => c && c === c.toUpperCase())
    .slice(0, 2)
    .join("") || String(name || "?").slice(0, 1).toUpperCase();

export function Avatar({ src, name, size = 44, muted = false, className = "" }) {
  const style = { width: size, height: size };
  if (src) return <img src={src} alt="" style={style} className={classNames("shrink-0 rounded-full object-cover", className)} />;
  return (
    <span
      style={{ ...style, background: muted ? "#B9B1BB" : AVATAR_BG[hash(name) % AVATAR_BG.length], fontSize: Math.round(size / 2.8) }}
      className={classNames("flex shrink-0 items-center justify-center rounded-full font-black text-white", className)}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </span>
  );
}

/**
 * Club-membership status of a getMyClubMembers row.
 * guest = booked a free trial class (no account / password yet, not a member until "Add to members").
 * pending = not activated: hasn't chosen a password yet (club-added, or a guest just made a member).
 */
export const memberStatus = (row) => {
  const c = row?.consumer_detail || {};
  if (c.clubMemberStatus === "removed") return { key: "removed", label: "Removed", tone: "red" };
  if (c.clubMemberStatus === "guest") return { key: "guest", label: "Guest", tone: "blue" };
  if (c.isVerified !== true || c.accountActivated === false) return { key: "pending", label: "Not activated", tone: "amber" };
  return { key: "active", label: "Active", tone: "green" };
};

/**
 * A purchase_detail entry of a getMyClubMembers row, in the shape purchaseStatus reads (getMyPurchases rows), so the
 * list and the member page use the same rules (2026-11-01: a removed pass with 2 credits left still added 2 credits
 * in the list). Older backends don't send status / dates: then it counts as before.
 */
const listPurchaseAsRow = (p) => ({
  status: p?.status,
  paymentStatus: p?.paymentStatus,
  purchaseExpiredDate: p?.purchaseExpiredDate,
  total_voucher_unused: p?.total_voucher_unused,
  selectedPassDetail: {
    productType: p?.productType,
    isCancel: p?.isCancel,
    cancelType: p?.cancelType,
    validUntilConsumed: p?.validUntilConsumed,
    unlimitedCredits: p?.unlimitedCredits,
  },
});

/** Credits column of a getMyClubMembers row: only usable passes / subscriptions count, as on the member page. */
export const memberCredits = (row) => {
  if (memberStatus(row).key === "removed") return { label: "–", tone: "gray" };
  if (memberStatus(row).key === "guest") return { label: "Free trial", tone: "lilac" };
  const all = Array.isArray(row?.purchase_detail) ? row.purchase_detail : [];
  const list = all.filter((p) => purchaseStatus(listPurchaseAsRow(p)).active);
  // same as the member page: a subscription is unlimited unless it says unlimitedCredits: false
  if (list.some((p) => p.productType === "subscription" && p.unlimitedCredits !== false)) return { label: "Unlimited", tone: "lilac" };
  const n = list.reduce((sum, p) => sum + Math.max(0, parseInt(p.total_voucher_unused, 10) || 0), 0);
  if (n > 0) return { label: `${n} ${n === 1 ? "credit" : "credits"}`, tone: "green" };
  return { label: "No credits", tone: "amber" };
};

export const fmtDate = (d, f = "D MMM YYYY") => (d ? moment(d).format(f) : "");
export const euro = (n) => `€${(parseFloat(n) || 0).toFixed(2).replace(".", ",")}`;

/** Phone number shown for a user record. */
export const phoneOf = (u) => (u?.phoneNumber ? `${u.countryCode ? u.countryCode + " " : ""}${u.phoneNumber}` : "");
export const whatsappNumber = (u) => `${u?.countryCode || ""}${u?.phoneNumber || ""}`.replace(/[^\d]/g, "");

/** -------- Purchases (getMyPurchases rows) -------- */

export const purchaseName = (row) => {
  const n = row?.boughtPassDetails?.passName || row?.selectedPassDetail?.productName || row?.selectedPassDetail?.passName || "Product";
  return n.charAt(0).toUpperCase() + n.slice(1);
};

/** Status of a purchased pass / subscription, the same rules as the old products tab. */
export const purchaseStatus = (row) => {
  const d = row?.selectedPassDetail || {};
  const expired = row?.purchaseExpiredDate && moment(row.purchaseExpiredDate).isBefore(moment());
  if (d.productType === "subscription") {
    if (d.isCancel === true && d.cancelType === "end_of_the_current_period" && !expired)
      return { label: `Cancels ${fmtDate(row.purchaseExpiredDate, "D MMM")}`, tone: "amber", active: true, cancelling: true };
    if (d.isCancel === true) return { label: "Cancelled", tone: "red", active: false };
    if (row?.paymentStatus === "Unpaid") return { label: "Awaiting payment", tone: "amber", active: !expired };
    if (expired) return { label: "Ended", tone: "gray", active: false };
    return { label: "Active", tone: "green", active: true };
  }
  if (row?.status === "Cancelled" || d.isCancel === true) return { label: "Removed", tone: "red", active: false };
  if ((parseInt(row?.total_voucher_unused, 10) || 0) <= 0) return { label: "Used up", tone: "gray", active: false };
  if (!d.validUntilConsumed && expired) return { label: "Expired", tone: "gray", active: false };
  if (row?.paymentStatus === "Unpaid") return { label: "Awaiting payment", tone: "amber", active: true };
  return { label: "Active", tone: "green", active: true };
};

export const isFreePurchase = (row) => !(parseFloat(row?.selectedPassDetail?.price) > 0) || row?.selectedPassDetail?.isMigratedProduct === true;

/** -------- Stripe payments / invoices -------- */

const cleanLine = (s) =>
  String(s || "")
    .replace(/^\d+\s*[×x]\s*/i, "")
    .replace(/\s*\(at [^)]*\)\s*$/i, "")
    .trim();

export const paymentItem = (row) => {
  const l = Array.isArray(row?.line_items) ? row.line_items : [];
  return cleanLine(l[0]?.product_name || l[0]?.description) || "Payment";
};

export const paymentVia = (row) => {
  const ch = row?.payment_intent?.charges?.data?.[0];
  const pm = ch?.payment_method_details;
  if (pm?.type === "card") {
    const brand = pm.card?.brand ? pm.card.brand.charAt(0).toUpperCase() + pm.card.brand.slice(1) : "";
    return brand ? `Card · ${brand}` : "Card";
  }
  if (pm?.type === "ideal") return "iDEAL";
  if (pm?.type === "sepa_debit") return "SEPA direct debit";
  if (pm?.type === "bancontact") return "Bancontact";
  if (pm?.type) return pm.type.replace(/_/g, " ");
  if (row?.type === "invoice" && !row?.payment_intent) return "Cash at the studio";
  return row?.payment_intent ? "Online" : "–";
};

export const paymentStatus = (row) => {
  const ch = row?.payment_intent?.charges?.data?.[0];
  if (ch?.refunded) return { label: "Refunded", tone: "gray", refundable: false };
  if (ch?.amount_refunded > 0) return { label: `Refunded ${euro(ch.amount_refunded / 100)}`, tone: "amber", refundable: true, refundedCents: ch.amount_refunded };
  const st = row?.payment_intent?.status || row?.status;
  if (st === "succeeded" || st === "paid") return { label: "Paid", tone: "green", refundable: !!row?.payment_intent?.id };
  if (st === "processing") return { label: "Processing", tone: "blue", refundable: false };
  if (st === "canceled") return { label: "Cancelled", tone: "gray", refundable: false };
  return { label: st ? st.replace(/_/g, " ") : "Paid", tone: "gray", refundable: false };
};

export const invoiceItem = (inv) => {
  const line = inv?.lines?.data?.[0];
  return cleanLine(line?.price?.nickname || line?.description) || (inv?.subscription ? "Subscription" : "Invoice");
};

const INTERVAL = { day: "day", week: "week", month: "month", year: "year" };
export const invoiceFrequency = (inv) => {
  const plan = inv?.subscription?.plan || inv?.subscription?.items?.data?.[0]?.price?.recurring;
  if (!inv?.subscription) return "One-time";
  const interval = plan?.interval;
  const count = plan?.interval_count || 1;
  if (!interval) return "Subscription";
  return count === 1 ? `Every ${INTERVAL[interval] || interval}` : `Every ${count} ${INTERVAL[interval] || interval}s`;
};

export const invoiceStatus = (inv) => {
  const ch = inv?.payment_intent?.charges?.data?.[0];
  if (ch?.refunded) return { key: "refunded", label: "Refunded", tone: "gray" };
  if (inv?.status === "void") return { key: "void", label: "Void", tone: "gray" };
  if (inv?.status === "draft") return { key: "draft", label: "Draft", tone: "gray" };
  if (inv?.status === "paid") return inv?.payment_intent ? { key: "paid", label: "Paid", tone: "green" } : { key: "paid", label: "Paid · cash", tone: "green" };
  if (inv?.status === "uncollectible") return { key: "uncollectible", label: "Uncollectible", tone: "red" };
  if (inv?.status === "open") {
    if (inv?.due_date && moment.unix(inv.due_date).endOf("day").isBefore(moment())) return { key: "overdue", label: "Overdue", tone: "red" };
    return { key: "open", label: "Sent", tone: "blue" };
  }
  return { key: inv?.status || "", label: inv?.status || "", tone: "gray" };
};

export const REFUND_REASONS = [
  { value: "requested_by_customer", label: "Requested by member" },
  { value: "duplicate", label: "Duplicate payment" },
  { value: "fraudulent", label: "Fraudulent" },
  { value: "other", label: "Other" },
];

/** Run fn on an axios response; returns [ok, data, message]. */
export const apiResult = (res) => {
  const ok = res?.status === 200 && res?.data?.statusCode === 200;
  const msg = typeof res?.data?.message === "string" ? res.data.message : "";
  return [ok, res?.data?.data, msg];
};

export const COUNTRY_CODES = ["+31", "+32", "+49", "+33", "+44", "+34", "+39", "+351", "+41", "+43", "+45", "+46", "+47", "+48", "+353", "+90", "+91", "+1"];

/** POST bookings/resendWelcomeEmail {consumerId} — only for members who haven't activated their account. Returns [ok, message]. */
export const resendWelcomeEmail = async (consumerId) => {
  try {
    const res = await axiosInstance({ method: "post", url: `${getUrlForBookings()}resendWelcomeEmail`, data: { consumerId } });
    const [ok, data, msg] = apiResult(res);
    return [ok, ok ? `Welcome email sent to ${data?.email || "the member"}` : msg || "Couldn't send the email."];
  } catch (e) {
    return [false, "Couldn't reach the server. Please try again."];
  }
};
